export default Object.freeze({
  // IDENTITY_DELETE: 'IDENTITY_DELETE',
});
